

function FlexiItemHeader({headerprepend, headerappend, headervalue, localstate}) {
	console.log(localstate);

	return (
		<div style={{ textAlign: "center", padding:"5px" }}>
			<h2>{headerprepend}{localstate.itemdata['Name']}{headerappend}</h2>
		</div>
	)
}

export default FlexiItemHeader; 